import { NavLink, useLocation } from "react-router-dom";
import menu from "data/menuData";

const DesktopMenu: React.FC = () => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <nav className="desktop-menu">
      <ul>
        {menu.map((item, index) => (
          <li key={index} className="menu-item">
            {item.url && item.url !== "#" ? (
              item.url === pathname ? (
                <a href={item.url}>{item.title}</a>
              ) : (
                <NavLink to={item.url}>{item.title}</NavLink>
              )
            ) : (
              <span>{item.title}</span>
            )}

            {item.subMenu && (
              <>
                <span className="submenu-icon"></span>
                <ul
                  className={`submenu ${
                    item.subMenu.some((subItem) => subItem.subMenu)
                      ? "has-extra-submenu"
                      : ""
                  }`}
                >
                  {item.subMenu.map((subItem, subIndex) => (
                    <li key={subIndex}>
                      {subItem.subMenu ? (
                        subItem.url && subItem.url !== "#" ? (
                          subItem.external ? (
                            <a
                              href={subItem.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="small-title"
                            >
                              {subItem.title}
                            </a>
                          ) : subItem.url === pathname ? (
                            <a href={subItem.url} className="small-title">
                              {subItem.title}
                            </a>
                          ) : (
                            <NavLink to={subItem.url} className="small-title">
                              {subItem.title}
                            </NavLink>
                          )
                        ) : (
                          <span className="small-title">{subItem.title}</span>
                        )
                      ) : (
                        subItem.url &&
                        (subItem.external ? (
                          <a
                            href={subItem.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {subItem.title}
                          </a>
                        ) : subItem.url === pathname ? (
                          <a href={subItem.url}>{subItem.title}</a>
                        ) : (
                          <NavLink to={subItem.url}>{subItem.title}</NavLink>
                        ))
                      )}

                      {subItem.subMenu && (
                        <ul className="extra-submenu">
                          {subItem.subMenu.map((subSubItem, subSubIndex) => (
                            <li key={subSubIndex}>
                              {subSubItem.url && subSubItem.url !== "#" ? (
                                subSubItem.url === pathname ? (
                                  <a href={subSubItem.url}>
                                    {subSubItem.title}
                                  </a>
                                ) : (
                                  <NavLink to={subSubItem.url}>
                                    {subSubItem.title}
                                  </NavLink>
                                )
                              ) : (
                                <span className="small-title">
                                  {subSubItem.title}
                                </span>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default DesktopMenu;
